/**
 * @generated SignedSource<<b6682dc3820a8ecbb3ab58aee74560fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedStoryTellingText_storyTellingTab$data = {
  readonly contentBodyText: string;
  readonly contentCreatorAttribution: {
    readonly creatorBrowseUrl: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly creatorName: string;
  } | null;
  readonly contentHeader: string | null;
  readonly tabTitle: string;
  readonly tabType: string;
  readonly " $fragmentType": "PdpRespSharedStoryTellingText_storyTellingTab";
};
export type PdpRespSharedStoryTellingText_storyTellingTab$key = {
  readonly " $data"?: PdpRespSharedStoryTellingText_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedStoryTellingText_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedStoryTellingText_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "kind": "LinkedField",
      "name": "contentCreatorAttribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creatorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "creatorBrowseUrl",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentBodyText",
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "9fcae050928f596930f69ef1c9d053d6";

export default node;
